import { render, staticRenderFns } from "./SessionComplete.vue?vue&type=template&id=50c50628&scoped=true&"
import script from "./SessionComplete.vue?vue&type=script&lang=js&"
export * from "./SessionComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c50628",
  null
  
)

export default component.exports